/* eslint-disable camelcase */
import { handleActions, createAction } from 'redux-actions';

export interface TierResponse {
  id: string
  traffic_limit: number
  domains_limit: number
  billing_cycle: 'month' | 'year'
  price: number
  currency: string
}

interface TierState {
  isLoading: boolean
  failed: boolean
  details: TierResponse[] | null
}

const initialState: TierState = {
  isLoading: true,
  failed: false,
  details: null,
};

export const getTiersInitialized = createAction(
  '@platform/query/payments/tiers/get/init',
);
export const getTiersSucceeded = createAction(
  '@platform/query/payments/tiers/get/success',
  (payload: any) => payload,
);
export const getTiersFailed = createAction(
  '@platform/query/payments/tiers/get/failed',
);

export default handleActions<TierState, TierResponse[]>({
  [getTiersInitialized.toString()]: () => initialState,
  [getTiersSucceeded.toString()]: (state, { payload }) => ({
    ...state,
    isLoading: false,
    failed: false,
    details: payload,
  }),
  [getTiersFailed.toString()]: state => ({
    ...state,
    isLoading: false,
    failed: true,
  }),
}, initialState);
